/* eslint-disable react-refresh/only-export-components */
import { Box, Skeleton, TableCell, TableRow } from '@mui/material';
import { ReactElement } from 'react';

export const SimpleSkeleton = () => (
  <Skeleton variant="rounded" animation="pulse" height={16} />
);

export const SkeletonTableRow = ({ cells }: { cells: number }) => {
  const cellElements: ReactElement[] = [];
  for (let index = 0; index < cells; index += 1) {
    cellElements.push(
      <TableCell key={index}>
        <SimpleSkeleton />
      </TableCell>,
    );
  }
  return <TableRow>{cellElements}</TableRow>;
};

export const renderSkeletonTableRows = (rows: number, columns: number) => {
  const rowElements: ReactElement[] = [];
  for (let index = 0; index < rows; index += 1) {
    rowElements.push(<SkeletonTableRow key={index} cells={columns} />);
  }

  return rowElements;
};

export function renderSkeletonCards(amount: number): ReactElement[] {
  const skeletonElements: ReactElement[] = [];
  for (let i = 0; i < amount; i += 1) {
    skeletonElements.push(<Skeleton key={i} variant="rounded" height={120} />);
  }
  return skeletonElements;
}

export function renderSkeletonFormFields(amount: number): ReactElement[] {
  const fields: ReactElement[] = [];

  for (let i = 0; i < amount; i += 1) {
    fields.push(
      <Box key={`skeleton-field-${i}`} sx={{ mb: 2 }}>
        <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="rounded" height={40} />
      </Box>,
    );
  }

  // Optional: Submit button skeleton
  fields.push(
    <Box key="skeleton-submit" sx={{ mt: 3 }}>
      <Skeleton variant="rounded" width={120} height={40} />
    </Box>,
  );

  return fields;
}
